var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesRepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Add_Sales_Rep",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-15 -10 100 100",
    width: 140,
    height: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-519.904 -959.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11887",
    transform: "translate(519.904 959.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11888",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17064",
    d: "M0,325.92c.239-1.492.416-3,.728-4.473A28.438,28.438,0,0,1,23.5,299.715a33.021,33.021,0,0,1,4.671-.413c2.963-.064,5.93-.041,8.894-.013a28.4,28.4,0,0,1,27.044,20.924,33.36,33.36,0,0,1,1.029,6.845,2.688,2.688,0,0,1-1.6,2.915H1.592A3.337,3.337,0,0,1,0,328.382V325.92",
    transform: "translate(0 -255.852)",
    fill: "#5035ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17065",
    d: "M0,500.019a3.337,3.337,0,0,0,1.592,1.593H0Z",
    transform: "translate(0 -427.489)",
    fill: "#5035ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17066",
    d: "M89.805,19.541a19.538,19.538,0,1,1,19.5,19.546,19.574,19.574,0,0,1-19.5-19.546",
    transform: "translate(-76.778 0)",
    fill: "#5035ed"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17067",
    d: "M28.826,18.64A1.428,1.428,0,0,1,27.4,20.069H20.069V27.4a1.427,1.427,0,0,1-1.428,1.428H10.186A1.428,1.428,0,0,1,8.758,27.4V20.069H1.428A1.427,1.427,0,0,1,0,18.64V10.186A1.428,1.428,0,0,1,1.428,8.758H8.758V1.428A1.427,1.427,0,0,1,10.186,0H18.64a1.428,1.428,0,0,1,1.428,1.428V8.758H27.4a1.427,1.427,0,0,1,1.428,1.428Z",
    transform: "translate(565.097 996.349)",
    fill: "#98baff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesRepIcon);
export default __webpack_public_path__ + "static/media/SalesRepIcon.86bfade92840ab6bba40b2ee13efa711.svg";
export { ForwardRef as ReactComponent };